const usageReportSchema = {
  $id: "/usagereport",
  type: "object",
  properties: {},
  required: [],
  additionalProperties: true,
};

export default usageReportSchema;
